interface ExerciceCategoryData {
  id?: number;
  name?: string;
  colorHex?: string;
  textColorHex?: string;
  ordinal?: number;

  translations?: any;
}

export class ExerciceCategory {
  public static readonly ID_FORCE: number = 1;
  public static readonly ID_SPEED: number = 2;
  public static readonly ID_AGILITY: number = 3;
  public static readonly ID_TECH_TRAINING: number = 4;
  public static readonly ID_COMPETITION: number = 5;
  public static readonly ID_THERAPY: number = 6;
  public static readonly ID_RECOVERY: number = 7;
  public static readonly ID_ENDURANCE: number = 8;
  public static readonly ID_POWER: number = 9;

  public static getNonTranslatableFields(): string[] { return ['id', 'colorHex', 'textColorHex', 'ordinal']; }
  public static getTranslatableFields(): string[] { return ['name']; }
  public static getFields(): string[] { return ['id', 'name', 'colorHex', 'textColorHex', 'ordinal']; }
  public static getKeyFields(): string[] { return ['id']; }

  id?: number;
  name?: string;
  colorHex?: string;
  textColorHex?: string;
  ordinal?: number;

  translations?: any;

  public static fromAPI(data: ExerciceCategoryData): ExerciceCategory {
    let translationData: any = {};
    for (let i = 0; i < data.translations?.length; i++) {
      if (data.translations[i]['exerciceCategoryId'] === data['id']) {
        translationData = data.translations[i];
        i = data.translations?.length;
      }
    }
    return new ExerciceCategory({
      id: data.id,
      name: translationData.name ?? data.name,
      colorHex: data.colorHex,
      textColorHex: data.textColorHex,
      ordinal: data.ordinal
    });
  }

  public static fromAPIList(data: ExerciceCategoryData[]): ExerciceCategory[] {
    return data.map((item: ExerciceCategoryData) => ExerciceCategory.fromAPI(item));
  }

  constructor({id, name, colorHex, textColorHex, ordinal, translations} : ExerciceCategoryData) {
    this.id = id;
    this.name = name;
    this.colorHex = colorHex;
    this.textColorHex = textColorHex;
    this.ordinal = ordinal;

    this.translations = translations;
  }

  public toJson(): ExerciceCategoryData {
    return {
      id: this.id,
      name: this.name,
      colorHex: this.colorHex,
      textColorHex: this.textColorHex,
      ordinal: this.ordinal
    };
  }
}
